export const ORDERLOCATIONS = "ORDER_LOCATIONS";
export const ORDERLOCATIONS_ADD = "ORDER_LOCATIONS_ADD";
export const ORDERLOCATIONS_DELETE = "ORDER_LOCATIONS_DELETE";
export const ORDERLOCATIONS_EDIT = "ORDER_LOCATIONS_EDIT";

export const ORDERLOCATIONS_SET_ROW_DATA = "ORDER_LOCATIONS_SET_ROW_DATA";
export const ORDERLOCATIONS_SET_EDIT_DATA = "ORDER_LOCATIONS_SET_EDIT_DATA";

export const MODEL_OPEN = "ORDER_LOCATIONS_MODEL_OPEN";
export const MODEL_CLOSE = "ORDER_LOCATIONS_MODEL_CLOSE";

export const ORDERLOCATIONS_LIST_SUCCESSFUL = "ORDER_LOCATIONS_LIST_SUCCESSFUL";
export const ORDERLOCATIONS_ADD_SUCCESSFUL = "ORDER_LOCATIONS_ADD_SUCCESSFUL";
export const ORDERLOCATIONS_EDIT_SUCCESSFUL = "ORDER_LOCATIONS_EDIT_SUCCESSFUL";

export const API_ERROR = "API_ERROR";
export const SET_PARAMS = "ORDER_LOCATIONS_SET_PARAMS";

export const SELECT_CHANGEVALUE = "SELECT_CHANGEVALUE";
export const INPUT_CHANGEVALUE = "INPUT_CHANGEVALUE";

export const LOCATION_IMAGE = "Location_Image";
export const GET_Location_ROW_DATA = "get_Location_Row_Data";
export const Location_ROW_SUCCESSFUL = "Location_row_successfull";

export const CLEAR_ORDERLOCATION_DATA = "CLEAR_ORDERLOCATION_DATA";
